import { useState } from "react";
import { TagButton } from "./home.styled";

// TODO replace colors in tags.tsx and this file for the centralized color choices
export const Tag = ({tag, index, toggleTagFilter, filterTags, colors}) => {
    const [selected, setSelected] = useState(false);

    const handleToggleFilter = (tag) => {
        toggleTagFilter(tag);
        setSelected(!selected);
    }

    return(
        <TagButton
            isselected={selected.toString()}
            key={`filtered-item-tag-${index}`}
            className="filter-tag px-3 py-1 rounded-full text-xs font-medium transition-colors"
            style={{
            border: filterTags.includes(tag)
                ? `4px solid ${colors.mediumLightPurple}`
                : "4px solid rgba(255,255,255,0)",
            }}
            onClick={() => {
            handleToggleFilter(tag);
            }}
        >
            {tag}
        </TagButton>
    )
} 